export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-css3-bb974ea332313dfb4746bbba1a479c46.svg";